var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SM Logos"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.375 23.625L6.0305 18.6588C5.19047 17.2459 4.7069 15.5971 4.7069 13.8341C4.7069 8.61 8.9419 4.375 14.1659 4.375C19.39 4.375 23.625 8.61 23.625 13.8341C23.625 19.0581 19.39 23.2931 14.1659 23.2931C12.5765 23.2931 11.0796 22.8991 9.765 22.2068L4.375 23.625Z",
    fill: "#2CB742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.0248 16.7173C19.609 15.9314 18.0756 15.0328 18.0756 15.0328C17.7286 14.835 17.31 14.8129 17.1122 15.1655C17.1122 15.1655 16.6139 15.763 16.4872 15.849C15.9083 16.2411 15.3721 16.2259 14.8309 15.6847L13.573 14.4268L12.3151 13.1689C11.7738 12.6277 11.7587 12.0915 12.1508 11.5126C12.2367 11.3859 12.8342 10.8877 12.8342 10.8877C13.1868 10.6895 13.1647 10.2712 12.9669 9.92427C12.9669 9.92427 12.0683 8.39089 11.2825 7.97507C10.9482 7.79813 10.5377 7.86006 10.2704 8.12737L9.71494 8.68284C7.95275 10.445 8.82042 12.4343 10.5826 14.1965L12.1931 15.807L13.8036 17.4174C15.5658 19.1796 17.5552 20.0472 19.3174 18.2851L19.8728 17.7296C20.1402 17.4617 20.2018 17.0512 20.0248 16.7173Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.585bc177b6414c1e3f21d3b321dcdf6e.svg";
export { ForwardRef as ReactComponent };